import { Component, OnInit } from '@angular/core';
import { OeAppPersonService } from '../oe-app-person.service';
import { TranslatorLanguage } from '../types/translator-language';
import { TranslatorToolService } from './translator-tool.service';

@Component({
  selector: 'lp2-translator-tool',
  templateUrl: './translator-tool.component.html',
  styleUrls: ['./translator-tool.component.scss'],
})
export class TranslatorToolComponent implements OnInit {
  loading: boolean;
  targetLanguage: string;
  sourceLanguage: string;
  targetText: string;
  sourceText: string;
  supportedLanguages: Array<TranslatorLanguage>;

  constructor(private translatorToolService: TranslatorToolService, private oeAppPerson: OeAppPersonService) {}

  ngOnInit() {
    this.setSourceAndTargetLang();
  }

  private setSourceAndTargetLang() {
    this.supportedLanguages = this.translatorToolService.getTranslatorLanguages();
    const english = this.supportedLanguages.find((lang) => lang.isoCode === 'en');
    this.sourceLanguage = (english && english.isoCode) || this.supportedLanguages[0].isoCode;
    const personPreferredLanguage = this.oeAppPerson.preferredLang;
    const preferredLanguage = this.supportedLanguages.find((lang) => lang.isoCode === personPreferredLanguage);
    this.targetLanguage = (preferredLanguage && preferredLanguage.isoCode) || this.supportedLanguages[0].isoCode;

  }

  translate() {
    if (!this.sourceText) {
      return;
    }
    if (this.sourceLanguage === this.targetLanguage) {
      this.targetText = this.sourceText;
      return;
    }
    this.startLoading();
    this.targetText = '';
    this.translatorToolService
      .translate({ text: this.sourceText, sourceLanguage: this.sourceLanguage, targetLanguage: this.targetLanguage })
      .subscribe(
        (result) => {
          this.targetText = result.translation;
          this.stopLoading();
        },
        () => this.stopLoading()
      );
  }

  swapTargetAndSourceLang() {
    const tmp = this.sourceLanguage;
    this.sourceLanguage = this.targetLanguage;
    this.targetLanguage = tmp;

    if (this.targetText) {
      this.sourceText = this.targetText;
      this.translate();
    }
  }

  startLoading(): void {
    this.loading = true;
  }

  stopLoading(): void {
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/translator-tool/translator-tool.component.ts